import actionTypes from 'SRC/modules/redux/actionTypes'

export const setAuthLoading = (isLoading = false) => ({
  type: actionTypes.SET_AUTH_LOADING,
  payload: isLoading
})
